import {call, put} from 'redux-saga/effects';
import axios from 'axios';

import * as AuthActionType from '../actionType/auth.actionType';
import {getBaseUrl} from '../../utilities/filter.utility';
import appConfig from '../../../static/data/env/envSettings';
// import { call } from 'file-loader';

export function* loginSaga(reqObj) {
    try {
        const res = yield axios.post(
            `${getBaseUrl()}/${appConfig.serviceEndPoints.login}`,
            {...reqObj.payload}
        );
        if (res && res.data) {
            localStorage.setItem('jwtToken', res.data.token);
            let authResult = res.data.res;
            const errArray = authResult.split('|');
            if (errArray[1]) {
                const loginErr = errArray[1];
                yield put({
                    type: AuthActionType.LOGIN_ERROR,
                    payload: {
                        loginErr
                    }
                });
            } else {
                if (authResult === 'CATCmaInAccessibleLinkPage') {
                    const zonesRes = yield axios.post(
                        `${getBaseUrl()}/${appConfig.serviceEndPoints.zones}`
                    );
                    if (zonesRes && zonesRes.data) {
                        const zones = zonesRes.data.res;
                        if (zones.defLogIn === 2) {
                            authResult = 'errorLink';
                        }
                    }
                } else if (authResult === 'downloadCourseDocumentsPage') {
                    const zonesRes = yield axios.post(
                        `${getBaseUrl()}/${appConfig.serviceEndPoints.zones}`
                    );
                    if (zonesRes && zonesRes.data) {
                        const zones = zonesRes.data;
                        if (zones.defLogIn === 2) {
                            authResult = 'pdfDownload';
                        }
                    }
                }

                yield put({
                    type: AuthActionType.LOGIN_SUCCESS,
                    payload: {
                        loginSuccess: authResult
                    }
                });
            }
        }
    } catch (error) {
        yield put({
            type: AuthActionType.LOGIN_ERROR,
            payload: {
                loginErr: 'Technical difficulty. Please try later.'
            }
        });
    }
}

export function* validateVoucherUidSaga(reqObj) {
    try {
        const res = yield axios.post(
            `${getBaseUrl()}/${appConfig.serviceEndPoints.validateVoucherUid}`,
            {...reqObj.payload}
        );
        if (res && res.data) {
            const authResult = res.data;
            if (authResult !== 'validUUID') {
                yield put({
                    type: AuthActionType.VOUCHER_ERROR,
                    payload: {
                        voucherErr: authResult
                    }
                });
            } else {
                yield put({
                    type: AuthActionType.VOUCHER_SUCCESS,
                    payload: {
                        voucherSuccess: authResult
                    }
                });
            }
        }
    } catch (error) {
        yield put({
            type: AuthActionType.VOUCHER_ERROR,
            payload: {
                loginErr: 'Technical difficulty. Please try later.'
            }
        });
    }
}

export function* forgetPwdSaga(reqObj) {
    try {
        const res = yield axios.post(
            `${getBaseUrl()}/${appConfig.serviceEndPoints.forgotPass}`,
            {...reqObj.payload}
        );
        if (res && res.data) {
            const result = res.data;
            // const splitted = result.split('|');
            if (!result.isError) {
                yield put({
                    type: AuthActionType.FORGOT_SUCCESS,
                    payload: {
                        message: result.msg,
                        forgetSuccess: result.msg
                    }
                });
            } else {
                yield put({
                    type: AuthActionType.FORGOT_ERROR,
                    payload: {
                        message: result.msg,
                        forgetError: result.msg,
                        token: result.token,
                        captchaVal: result.captcha
                    }
                });
            }
        }
    } catch (error) {
        yield put({
            type: AuthActionType.FORGOT_ERROR,
            payload: {
                loginErr: 'Technical difficulty. Please try later.'
            }
        });
    }
}


function getCap(req) {
    // return axios.get('../../../static/data/voucher.json')
    //            .then(res => res.data);
    return axios.get(`${getBaseUrl()}/${appConfig.serviceEndPoints.getCaptchaValue}`)
                 .then(res => res.data);
}

export function *getCaptchaSaga(req) {
    // console.log('hello upper');
    // try {
    //     const response = yield axios.get(
    //         `${getBaseUrl()}/${appConfig.serviceEndPoints.getCaptchaValue}`
    //     );
    //     console.log('hello from captacha func', response);
    //     if (response) {
    //         const res = JSON.parse(response);
    //         const token = res.token;
    //         const captcha = res.captcha.split(' ');
    //         yield put({
    //             type: AuthActionType.GET_CAPTCHA_VALUE,
    //             payload: {
    //                 captchaL: captcha[0],
    //                 captchaR: captcha[2],
    //                 captchaOperator: captcha[1],
    //                 token: token
    //             }
    //         });
    //     }
    // } catch (error) {
    //     yield put({
    //         type: AuthActionType.CAPTCHA_ERROR,
    //         payload: {
    //             captchaError: 'Please refresh captcha'
    //         }
    //     });
    // }
    try {
        const val = yield call(getCap, req);
        yield put({
            type: AuthActionType.GET_VALUE,
            payload: {
                captchaVal: val.captcha,
                token: val.token
            }
        });
    } catch (error) {
        yield put({
            type: AuthActionType.CAPTCHA_ERROR,
            payload: {
                captchaError: 'Please refresh captcha'
            }
        });
    }
}

// function getValidation(req) {
//     return axios.get(`${getBaseUrl()}/${appConfig.serviceEndPoints.forgotPass}`)
//                 .then(res => res.data);
// }

// export function *checkValidation(req) {
//     try {
//         const val = yield call(getValidation, req);
//         yield put({
//             type: AuthActionType.CAPTCHA_VALIDATION,
//             payload: {
//                 setError: val.isError,
//                 validationMsg: val.msg,
//                 token: val.token,
//                 captcha: val.captcha
//             }
//         });
//     } catch (error) {
//         yield put({
//             type: AuthActionType.CAPTCHA_ERROR,
//             payload: {
//                 captchaError: 'Please refresh captcha'
//             }
//         });
//     }
// }
